import { render, staticRenderFns } from "./testList.vue?vue&type=template&id=26f752c4&"
import script from "./testList.vue?vue&type=script&lang=js&"
export * from "./testList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports